module.exports = __webpack_public_path__ + "static/media/Theatre Seat Naming Project.cced0c6b.png";